// extracted by mini-css-extract-plugin
export default {"Loader":"styles_Loader__pzPxP","logo":"styles_logo__stZCe"};